import React from "react"; // eslint-disable-line no-unused-vars
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async"; // eslint-disable-line no-unused-vars
import "./css/App.css";
import App from "./App"; // eslint-disable-line no-unused-vars
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./utils/reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister(); // Using custom service worker instead

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
reportWebVitals();
